<div class="card-body">
    <div id="apex-mixed-line-column-area-chart"></div>
</div>